import React, { Component } from 'react'
import InputSelectUI from './InputSelectUI.js'

class InputSelectSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: this.props.value,
      clientError: null
    }
  }

  render() {
    return (
      <InputSelectUI
        name={this.props.name}
        value={this.props.value}
        optionList={this.props.optionList}
        onChange={this.props.onChange}
        label={this.props.label}
        help={this.props.help}
        messageList={this.props.messageList}
        labelKey={this.props.labelKey}
        required={this.props.required}
        error={this.state.clientError || this.props.error}
        setClientError={this.setClientError}
      />
    )
  }

  // this is used in FormSF (dynamically) to change border color
  setClientError = (clientError) => {
    this.setState({ clientError: clientError })
  }

}

export default InputSelectSF
